import React from 'react';
import { useTheme } from '../contexts/ThemeContext';
import { getThemeColors } from '../utils/themeColors';

interface CTACardProps {
  onClose: () => void;
}

const CTACard_3: React.FC<CTACardProps> = ({ onClose }) => {
  const { isDark, isHighContrast } = useTheme();
  const colors = getThemeColors('dark', isDark, isHighContrast);

  const handleWhatsAppClick = () => {
    const message = encodeURIComponent('Olá! Gostaria de fazer uma cotação de seguro auto. Vi as avaliações e fiquei interessado!');
    window.open(`https://wa.me/41764791479?text=${message}`, '_blank');
  };

  return (
    <div style={{
      background: `linear-gradient(45deg, ${colors.primaryText} 0%, ${colors.accentText} 100%)`,
      borderRadius: 16,
      padding: 'clamp(1.5rem, 4vw, 2rem)',
      margin: 'clamp(1.5rem, 4vw, 2rem) 0',
      position: 'relative',
      overflow: 'hidden',
      color: 'white'
    }}>
      {/* Background Pattern */}
      <div style={{
        position: 'absolute',
        top: -50,
        right: -50,
        width: 200,
        height: 200,
        background: 'rgba(255, 255, 255, 0.1)',
        borderRadius: '50%',
        zIndex: 0
      }} />
      <div style={{
        position: 'absolute',
        bottom: -30,
        left: -30,
        width: 150,
        height: 150,
        background: 'rgba(255, 255, 255, 0.05)',
        borderRadius: '50%',
        zIndex: 0
      }} />
      
      <div style={{ position: 'relative', zIndex: 1 }}>
        <div style={{
          display: 'flex',
          alignItems: 'flex-start',
          justifyContent: 'space-between',
          gap: 'clamp(1rem, 3vw, 1.5rem)',
          flexWrap: 'wrap'
        }}>
          <div style={{ flex: 1, minWidth: '250px' }}>
            <div style={{
              display: 'flex',
              alignItems: 'center',
              gap: '0.5rem',
              marginBottom: '0.5rem'
            }}>
              <span style={{ fontSize: '1.5rem' }}>🎯</span>
              <span style={{
                fontSize: 'clamp(0.8rem, 2.2vw, 0.9rem)',
                fontWeight: 600,
                background: 'rgba(255, 255, 255, 0.2)',
                padding: '0.3rem 0.8rem',
                borderRadius: 20,
                backdropFilter: 'blur(10px)'
              }}>
                OFERTA ESPECIAL
              </span>
            </div>
            
            <h3 style={{
              fontSize: 'clamp(1.3rem, 4vw, 1.6rem)',
              fontWeight: 700,
              margin: '0 0 0.5rem 0',
              lineHeight: 1.2
            }}>
              Cotação Gratuita em 5 Minutos!
            </h3>
            
            <p style={{
              fontSize: 'clamp(0.9rem, 2.5vw, 1rem)',
              margin: '0 0 1rem 0',
              lineHeight: 1.4,
              opacity: 0.9
            }}>
              Compare preços das melhores seguradoras e economize até 10% no seu seguro auto
            </p>
            
            <div style={{
              display: 'flex',
              alignItems: 'center',
              gap: '1rem',
              flexWrap: 'wrap'
            }}>
              <div style={{
                display: 'flex',
                alignItems: 'center',
                gap: '0.3rem',
                fontSize: 'clamp(0.8rem, 2.2vw, 0.9rem)',
                opacity: 0.8
              }}>
                <span>✅</span>
                <span>Sem compromisso</span>
              </div>
              <div style={{
                display: 'flex',
                alignItems: 'center',
                gap: '0.3rem',
                fontSize: 'clamp(0.8rem, 2.2vw, 0.9rem)',
                opacity: 0.8
              }}>
                <span>✅</span>
                <span>100% online</span>
              </div>
            </div>
          </div>
          
          <div style={{
            display: 'flex',
            flexDirection: 'column',
            gap: '0.8rem',
            alignItems: 'stretch'
          }}>
            <button
              onClick={handleWhatsAppClick}
              style={{
                background: 'white',
                color: '#1e293b',
                border: 'none',
                borderRadius: 12,
                padding: 'clamp(0.8rem, 2.5vw, 1rem) clamp(1.5rem, 4vw, 2rem)',
                fontSize: 'clamp(0.9rem, 2.5vw, 1rem)',
                fontWeight: 600,
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: '0.5rem',
                transition: 'all 0.3s ease',
                boxShadow: '0 4px 15px rgba(0, 0, 0, 0.2)',
                minWidth: '180px'
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = 'translateY(-2px)';
                e.currentTarget.style.boxShadow = '0 6px 20px rgba(0, 0, 0, 0.3)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = '0 4px 15px rgba(0, 0, 0, 0.2)';
              }}
            >
              <span style={{ fontSize: '1.2rem' }}>💬</span>
              WhatsApp Rápido
            </button>
            
            <button
              onClick={onClose}
              style={{
                background: 'transparent',
                color: 'white',
                border: '2px solid rgba(255, 255, 255, 0.3)',
                borderRadius: 12,
                padding: 'clamp(0.6rem, 2vw, 0.8rem) clamp(1.5rem, 4vw, 2rem)',
                fontSize: 'clamp(0.8rem, 2.2vw, 0.9rem)',
                fontWeight: 500,
                cursor: 'pointer',
                transition: 'all 0.3s ease',
                minWidth: '180px',
                justifyContent: 'center'
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.background = 'rgba(255, 255, 255, 0.1)';
                e.currentTarget.style.borderColor = 'rgba(255, 255, 255, 0.5)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.background = 'transparent';
                e.currentTarget.style.borderColor = 'rgba(255, 255, 255, 0.3)';
              }}
            >
              Fechar
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CTACard_3; 